module.exports = __webpack_public_path__ + "static/btnTip2.d4b866ff.png";